import { Component, Input, forwardRef, inject } from '@angular/core';
import { FormArray, FormGroup, FormsModule } from '@angular/forms';
import { Country } from 'src/app/services/countries/countries.service';
import { RepresentativeType } from 'src/types';
import {
  EditCaseDialogService,
  RepresentativeControls,
} from '../edit-case-dialog.service';
import { RepresentativeFormComponent } from '../representative-form/representative-form.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-representatives-form',
  templateUrl: './representatives-form.component.html',
  styleUrls: ['./representatives-form.component.scss'],
  imports: [FormsModule, forwardRef(() => RepresentativeFormComponent), PayeeButtonComponent],
})
export class RepresentativesFormComponent {
  private editCaseDialogService = inject(EditCaseDialogService);

  @Input() index: string = '';

  @Input() isChild = false;
  @Input({ required: true }) representatives!: FormArray<
    FormGroup<RepresentativeControls>
  >;
  @Input({ required: true }) representativeTypes!: RepresentativeType[];
  @Input({ required: true }) countries!: Country[];

  get showAddRepresentativeButton(): boolean {
    if (!this.representatives || this.representatives.disabled) {
      return false;
    }

    if (!this.isChild) {
      return this.representatives.length < 2;
    } else {
      return this.representatives.length === 1;
    }
  }

  addJointRep(): void {
    if (!this.representatives) {
      return;
    }

    this.editCaseDialogService.addRepresentative(this.representatives);
  }
}
